<template>
  <b-modal :active="active" has-modal-card :on-cancel="() => $emit('close')">
    <div class="clone-flow modal-content">
      <div class="box">
        <header class="title is-5">Clone Flow - {{ flowId }}</header>
        <form class="clone-flow__form" @submit.prevent="createCloneHandler">
          <b-field>
            <b-input
              v-model="id"
              icon="format-title"
              placeholder="New Flow Name"
              type="text"
            />
          </b-field>
          <b-button
            class="is-fullwidth"
            :loading="submitting"
            native-type="submit"
            type="is-primary"
            >Create Clone</b-button
          >
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import regex from '../../utils/regex';

export default {
  props: {
    active: Boolean,
    flowId: String
  },
  data: function() {
    return {
      id: ''
    };
  },
  computed: {
    ...mapState({
      submitting: state => state.flows.submitting
    })
  },
  methods: {
    ...mapActions('flows', ['cloneFlow']),
    async createCloneHandler() {
      if (!this.isNameValid(this.id)) {
        this.$buefy.toast.open({
          message: regex.flowName.message,
          type: 'is-danger'
        });
        return;
      }

      try {
        await this.cloneFlow({ id: this.id });
        this.$buefy.toast.open({
          message: 'Flow cloned successfully!',
          type: 'is-success'
        });
        this.$emit('close');
        this.$router.replace(`/flows/edit/${this.id}`);
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to clone flow!',
          type: 'is-danger'
        });
      }
    },
    isNameValid(name) {
      return regex.flowName.pattern.test(name);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.clone-flow {
  width: auto;

  &__form {
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
